/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Friend_Guest_Error_DayInputs */

const fr_membership_friend_guest_error_day = /** @type {(inputs: Membership_Friend_Guest_Error_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce jour n'est pas possible.`)
};

/**

* @param {Membership_Friend_Guest_Error_DayInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_friend_guest_error_day = /** @type {((inputs?: Membership_Friend_Guest_Error_DayInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Friend_Guest_Error_DayInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_friend_guest_error_day(inputs)
});